var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchSend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.01 3.55002L9.52 6.77002L2 5.77002L2.01 3.55002ZM9.51 12.27L2 15.49V13.27L9.51 12.27ZM0.00999999 0.52002L0 7.52002L15 9.52002L0 11.52L0.00999999 18.52L21 9.52002L0.00999999 0.52002Z",
    fill: "#5627D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSend);
export default __webpack_public_path__ + "static/media/search-send.fdf348e5cb85fd2be0d7d4be0f92a4b4.svg";
export { ForwardRef as ReactComponent };